"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_environment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "46478b38-52d6-4779-9350-b401f7dfee7c",
    x1: 103.91,
    y1: 80.75,
    x2: 139.82,
    y2: 116.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#666",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#666",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "environment-hi"), /*#__PURE__*/React.createElement("g", {
    id: "52efdb3b-214a-4865-9256-69053491076b",
    "data-name": "environment-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "578ce842-6ea2-4a2b-aad3-9609262ba9cb",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f8f6a8b-238c-4a51-973e-262e294d507d",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f3a0b211-bd09-4321-9f75-d0e65188b82f",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e84e2438-59ad-4e3f-a7af-041d5811b52c",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dde82dd6-108d-4bdf-a040-0bfe4e65c741",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "277f567e-21b5-4f8d-b8e3-eb47299d08a9",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0f41f965-1645-4906-a3c0-c0e48ffa9511",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1d98b0c3-0eee-46d3-ad47-83559759bc93",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8bc9e476-7517-44cc-aeab-1111dfbd7faa",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a97a8818-3292-41a8-a9be-56c43bfe3384",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb004b66-0737-41f8-b671-0330aeb1103f",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2a137a7d-d2a7-46d8-bf13-df242922daf8",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1dc2c2c5-dafd-4694-8f02-53baf6aea284",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "62eaea30-9cca-4e96-b83f-c16c3c569d38",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "566ab84d-dc62-42d0-8810-595379588533",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "666128ae-cf19-4669-b0b6-520af538cd15",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8a5f97ab-33a8-4138-bb52-23bbaece465a",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "be3ca495-3a77-46e5-9b14-1f2669889de1",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c3bdbbbe-f9d2-43b4-8592-a7e2334306df",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9c295ce-bdfd-420a-a078-17d4e3f26848",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5bb6bfd9-aaa5-4c66-8063-4f12aa722145",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "783b3442-9fa2-4c1c-b96e-c48ea0629d70",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f10b3658-344f-4cc4-b028-e89736d26dc9",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "359b5cb9-116f-40e8-90a2-574ec664edab",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0849b2b9-f085-4161-a0ee-703440b4625e",
    "data-name": "Public_sector_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ec2a95a8-80db-415b-8ec7-77388a6ab0c8",
    "data-name": "Extras_services_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8,166.3a4,4,0,0,1-3.37-6.15,371.59,371.59,0,0,1,93.15-99.87,4,4,0,0,1,4.75,6.44,363.59,363.59,0,0,0-91.15,97.72A4,4,0,0,1,34.8,166.3Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,64.73a363.6,363.6,0,0,0-91.15,97.72,4,4,0,0,1-7.23-1.13,4,4,0,0,0,7.23,3.13,363.6,363.6,0,0,1,91.15-97.72,4,4,0,0,0,1.49-4.24A4,4,0,0,1,129.33,64.73Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.05,142.41l-1.73,0A89.86,89.86,0,0,1,53,139.15a4,4,0,0,1-2.81-2.88A89.61,89.61,0,0,1,161.11,28.19a4,4,0,0,1,2.81,2.88A89.63,89.63,0,0,1,77.05,142.41Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,133.53a89.81,89.81,0,0,1-2.49-19.65,89.85,89.85,0,0,0,2.15,20.17",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.57,54.56a89.82,89.82,0,0,0-2.65-23.48,4,4,0,0,0-.17-.51c-18,16.54-40.19,34.48-58.42,49.77-19,15.92-38.27,40-54.26,57.58A4,4,0,0,0,53,139.15a89.86,89.86,0,0,0,22.31,3.24l1.73,0A89.66,89.66,0,0,0,166.57,54.56Z",
    fill: "url(#46478b38-52d6-4779-9350-b401f7dfee7c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35,139.76a95.09,95.09,0,0,0,20,2.63l1.73,0a89.66,89.66,0,0,0,89.51-87.85q0-1.57,0-3.13c0,.38,0,.75,0,1.13a89.66,89.66,0,0,1-89.51,87.85l-1.73,0a90.07,90.07,0,0,1-18.67-2.31,26.09,26.09,0,0,1-4.37-1.58l-1.19,1.44S51.82,138.93,55.35,139.76Z",
    opacity: 0.06
  })))))))))))))))))))))))))))));
}

var _default = ic_environment;
exports.default = _default;